<template>
    <div class="situation">
        <div class="target">
            <div class="user_info">
                <div class="user-num">
                    <h1>总用户数</h1>
                    <h2>{{totalNum}}</h2>
                </div>
                <div class="pie-echarts">
                    <template>
                        <UserStagePieECharts :pie-data="pieData" :autoresize="isAutoresize"></UserStagePieECharts>
                    </template>
                </div>
            </div>
            <div class="data-info">
                <div class="target-one" @click="selectLineChart(1)" :title="addMsg">
                    <h1>日新增(注册)</h1>
                    <h2>{{newRegisterUserDay}}</h2>
                    <!--                    <p>昨日 {{newRegisterUserYesterday}}</p>-->
                    <p>同比 {{newRegisterUserChange|getPercent}}
                        <Icon v-if="newRegisterUserChange >= 0" color="red" type="md-trending-up"/>
                        <Icon v-else color="green" type="md-trending-down"/>
                    </p>
                    <p>7日平均 {{newRegisterUser7AverDay}}</p>
                </div>
                <div class="target-one" @click="selectLineChart(2)" :title="stayMsg">
                    <h1>新用户次留</h1>
                    <h2>{{newUserStay}}%</h2>
                    <!--                    <p>昨日 {{newUserStayYesterday}}</p>-->
                    <p>同比 {{newUserStayChange|getPercent}}
                        <Icon v-if="newUserStayChange >= 0" color="red" type="md-trending-up"/>
                        <Icon v-else color="green" type="md-trending-down"/>
                    </p>
                    <p>7日平均 {{newUserStay7AverDay}}%</p>
                </div>
                <div class="target-one" @click="selectLineChart(3)" :title="earnMsg">
                    <h1>日收益</h1>
                    <h2>{{earningsDay}}</h2>
                    <!--                    <p>昨日 {{earningsYesterday}}</p>-->
                    <p>同比 {{earningsChange|getPercent}}
                        <Icon v-if="earningsChange >= 0" color="red" type="md-trending-up"/>
                        <Icon v-else color="green" type="md-trending-down"/>
                    </p>
                    <p>7日平均 {{earnings7DayAverDay}}</p>
                </div>

                <div class="target-one" @click="selectLineChart(4)" :title="startMsg">
                    <h1>日活跃(启动)</h1>
                    <h2>{{activeStartDay}}</h2>
                    <!--                    <p>昨日 {{activeStartYesterday}}</p>-->
                    <p>同比 {{activeStartChange|getPercent}}
                        <Icon v-if="activeStartChange >= 0" color="red" type="md-trending-up"/>
                        <Icon v-else color="green" type="md-trending-down"/>
                    </p>
                    <p>7日平均 {{activeStart7AverDay}}</p>
                </div>
                <div class="target-one" @click="selectLineChart(5)" :title="studyMsg">
                    <h1>日活跃(自习)</h1>
                    <h2>{{activeStudyDay}}</h2>
                    <!--                    <p>昨日 {{activeStudyYesterday}}</p>-->
                    <p>同比 {{activeStudyChange|getPercent}}
                        <Icon v-if="activeStudyChange >= 0" color="red" type="md-trending-up"/>
                        <Icon v-else color="green" type="md-trending-down"/>
                    </p>
                    <p>7日平均 {{active7AverDay}}</p>
                </div>
                <div class="target-one" @click="selectLineChart(6)" :title="studyTimeMsg">
                    <h1>日均自习时长</h1>
                    <h2>{{studyTimeDay}}</h2>
                    <!--                    <p>昨日 {{studyTimeYesterday}}</p>-->
<!--                    <p>同比 {{studyTimeChange|getPercent}}-->
<!--                        <Icon v-if="studyTimeChange >= 0" color="red" type="md-trending-up"/>-->
<!--                        <Icon v-else color="green" type="md-trending-down"/>-->
<!--                    </p>-->
                    <p>7日平均 {{studyTime7AverDay}}</p>
                </div>
            </div>
        </div>
        <hr>
        <div class="trend">
            <div class="time-box">
                <date-select @transmit="getSelectDate"></date-select>
            </div>
            <div class="chart-box">
                <UserSituationLineECharts ref="line_charts" :line-data="lineData"></UserSituationLineECharts>
            </div>
        </div>
    </div>
</template>

<script>

    // @ is an alias to /src
    import HelloWorld from '@/components/HelloWorld.vue'
    import UserStagePieECharts from "../components/UserStagePieEcharts";
    import DateSelect from "../components/DateSelect";
    import UserSituationLineECharts from "../components/UserSituationLineECharts";
    import apis from '../http/api'

    export default {
        name: 'Home',
        components: {
            UserStagePieECharts,
            DateSelect,
            UserSituationLineECharts,
            HelloWorld
        },
        data() {
            return {
                addMsg: "前一天新增注册用户，点击展示折线图",
                stayMsg: "两天前新增注册用户第二天的留存率，点击展示折线图",
                earnMsg: "前一天收益金额，单位:元，点击展示折线图",
                startMsg: "前一天启动app的人数，点击展示折线图",
                studyMsg: "前一天自习的人数，点击展示折线图",
                studyTimeMsg: "前一天平均自习时长，单位:h，点击展示折线图",
                isAutoresize: true,
                totalNum: "",                    // 总用户数
                newRegisterUserDay: "",          // 日新增注册用户
                newRegisterUserYesterday: "",    // 昨日新增注册用户
                newRegisterUserChange: "",       // 注册同比变化
                newRegisterUser7AverDay: "",     // 7日平均日新增注册用户
                newUserStay: "",                 // 新用户次留
                newUserStayYesterday: "",        // 昨日新用户次留
                newUserStayChange: "",           // 次留同比变化
                newUserStay7AverDay: "",         // 7日平均新用户次留
                earningsDay: "",                 // 日收益
                earningsYesterday: "",           // 昨日收益
                earningsChange: "",              // 收益同比变化
                earnings7DayAverDay: "",         // 7日平均收益
                activeStartDay: "",              // 日活跃（启动）
                activeStartYesterday: "",        // 昨日活跃（启动）
                activeStartChange: "",           // 同比变化(启动)
                activeStart7AverDay: "",         // 7日平均活跃（启动）
                activeStudyDay: "",             // 日活跃（自习）
                activeStudyYesterday: "",       // 昨日活跃（自习）
                activeStudyChange: "",           // 同比变化（自习）
                active7AverDay: "",              // 7日平均活跃（自习）
                studyTimeDay: "",               // 日均自习时长
                studyTimeYesterday: "",          // 昨日日均自习时长
                studyTimeChange: "",             // 自习时长同比变化
                studyTime7AverDay: "",            // 7日平均自习时长
                startSelectDate: null,          // 选择器开始时间
                endSelectDate: null,            // 选择器结束时间
                showType: 1,                     // 展示哪一个折线图
                lineData: {},                   //折线图数据
                pieData: [],                     //饼图数据
            }
        },
        created() {
            this.getSituationData();
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 - 1));
            this.startSelectDate = this.$moment(start).format("YYYY-MM-DD");
            this.endSelectDate = this.$moment(end).format("YYYY-MM-DD");
            this.getSituationDaysData()
        },
        methods: {
            getSituationData() {
                apis.user_info().then(res => {
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {
                        this.totalNum = data.user_count;
                        this.pieData = data.stage;
                    }
                }).catch();

                apis.user_situation().then(res => {
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {
                        this.newRegisterUserDay = data.new_add_day.today;
                        // this.newRegisterUserYesterday = data.new_add_day.yesterday;
                        this.newRegisterUserChange = data.new_add_day.change;
                        this.newRegisterUser7AverDay = data.new_add_day.average;

                        this.earningsDay = data.earnings_day.today;
                        // this.earningsYesterday = data.earnings_day.yesterday;
                        this.earningsChange = data.earnings_day.change;
                        this.earnings7DayAverDay = data.earnings_day.average;

                        this.activeStartDay = data.start_active_day.today;
                        // this.activeStartYesterday = data.start_active_day.yesterday;
                        this.activeStartChange = data.start_active_day.change;
                        this.activeStart7AverDay = data.start_active_day.average;

                        this.activeStudyDay = data.study_active_day.today;
                        // this.activeStudyYesterday = data.study_active_day.yesterday;
                        this.activeStudyChange = data.study_active_day.change;
                        this.active7AverDay = data.study_active_day.average;

                        this.studyTimeDay = data.aver_study_time.today;
                        // this.studyTimeYesterday = data.aver_study_time.yesterday;
                        // this.studyTimeChange = data.aver_study_time.change;
                        this.studyTime7AverDay = data.aver_study_time.average;
                    }
                }).catch();
                apis.user_situation_stay().then(res => {
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {
                        this.newUserStay = data.new_stay_day.today;
                        // this.newUserStayYesterday = data.new_stay_day.yesterday;
                        this.newUserStayChange = data.new_stay_day.change;
                        this.newUserStay7AverDay = data.new_stay_day.average;
                    }
                }).catch()
            },
            getSelectDate(data) {
                this.startSelectDate = this.$moment(data[0]).format("YYYY-MM-DD");
                this.endSelectDate = this.$moment(data[1]).format("YYYY-MM-DD");
                this.getSituationDaysData()
            },
            getSituationDaysData() {
                try {
                    this.$refs.line_charts.loading();
                }catch (e) {
                    console.log('showLoading Error')
                }
                let param_data = {
                    'start_date': this.startSelectDate,
                    'end_date': this.endSelectDate,
                    'type': this.showType
                };
                apis.user_situation_range(param_data).then(res => {
                    const {data, errCode, msg} = res;
                    const lineData = {data: data};
                    if (errCode === 0) {
                        if (this.showType === 1) {
                            lineData['settings'] = {
                                legendData: ['日新增(注册)']
                            };
                        } else if (this.showType === 2) {
                            lineData['settings'] = {
                                legendData: ['新用户次留']
                            };
                        } else if (this.showType === 3) {
                            lineData['settings'] = {
                                legendData: ['日收益']
                            };
                        } else if (this.showType === 4) {
                            lineData['settings'] = {
                                legendData: ['日活跃(启动)']
                            };
                        } else if (this.showType === 5) {
                            lineData['settings'] = {
                                legendData: ['日活跃(自习)']
                            };
                        } else if (this.showType === 6) {
                            lineData['settings'] = {
                                legendData: ['日均自习时长']
                            };
                        }
                        this.lineData = lineData;
                    }
                }).catch()
            },
            selectLineChart(showType){
                this.showType = showType;
                this.getSituationDaysData()
            }
        },
        filters: {
            getPercent(val) {
                if (val >= 0) {
                    return '+' + val + '%'
                } else {
                    return val + '%'
                }
            }
        }
    }
</script>

<style scoped>
    .situation {
        margin: 10px;
    }

    .target {
        display: flex;
        justify-content: center;

    }

    .user_info {
        display: flex;
        justify-content: center;
        width: 40%;
        flex-wrap: wrap;
    }

    .pie-echarts {
        width: 100%;
        height: 200px;
    }

    .data-info {
        display: flex;
        width: 60%;
        flex-wrap: wrap;
    }

    .target-one {
        text-align: center;
        width: 30%;
        /*min-width: 400px;*/
        height: 150px;
        /*padding-bottom: 20px;*/
        cursor: pointer;
    }

    .time-box {
        text-align: center;
        margin-top: 10px;
    }

    .user-num {
        text-align: center;
        height: 100px;
    }

    .chart-box {
        width: 100%;
    }
</style>